import { useContext } from "react";
import { SnackbarErrorsContext } from "../providers/SnackbarErrorsProvider";

export default function useSnackbarErrors() {
  return useContext(SnackbarErrorsContext);
}
